var LadderConst = {}

//天梯红点类型
LadderConst.RedType = {
    TopThree: 1,  // 英雄殿
    BattleLog: 2, // 战报
    Challenge: 3, // 挑战次数
}

module.exports = LadderConst;